module.exports = __webpack_public_path__ + "img/overwhelming_blink.aa791163.png";